import React from 'react'
import { NavBar } from './navBar/NavBar'

export const Layout = props => (
    <React.Fragment>
        <NavBar />
            {
                props.children
            }
    </React.Fragment>
)